import { StringUtils } from '@brunommsilva/react-foundations';
import { Dropdown } from '@brunommsilva/react-foundations';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TransactionType } from '../../models/transactions';

interface Props {
  selected?: { id: string; name: string };
  onSelected: (type?: { id: string; name: string }) => void;
  size?: 'small' | 'medium';
}

const TransactionTypeDropdown = ({ selected, onSelected, size }: Props) => {
  const { t } = useTranslation();
  const allOptions = Object.values(TransactionType).map((type) => ({
    id: type,
    label: t(`TRANSACTION_TYPE_${type}`),
  }));
  const [options, setOptions] = useState(allOptions);

  const fetchOptions = (search?: string) => {
    if (!search) {
      setOptions(allOptions);
      return;
    }

    setOptions(
      allOptions.filter(({ label }) => StringUtils.hasMatch(label, search))
    );
  };

  const handleSelected = (id?: string) => {
    if (!id) {
      onSelected(undefined);
      return;
    }
    onSelected({ id, name: t(`TRANSACTION_TYPE_${id}`) });
  };

  const selectedOption = selected
    ? { id: selected.id, label: selected.name }
    : undefined;

  return (
    <Dropdown
      label={t('TRANSACTION_TYPE')}
      onSelected={handleSelected}
      selected={selectedOption}
      fetchOptions={fetchOptions}
      options={options}
      size={size}
    />
  );
};

export default TransactionTypeDropdown;
